import React from 'react';

import { useSeoMetada } from '../hooks/useSeoMetadata';

import Layout from '../components/Layout';
import Preferences from '../components/Preferences';

const PreferencesContainer = ({ data }) => {
  const { helmetMetadata } = useSeoMetada(
    {},
    {
      title: `Preferences page`,
      description: 'Enable or disable email notifications'
    }
  );

  return (
    <Layout
      data={{
        ...data,
        content: {
          contentful_id: 'preferences'
        }
      }}
      helmetMetadata={helmetMetadata}
    >
      <Preferences />
    </Layout>
  );
};

export default PreferencesContainer;
